import { Navigate, Outlet } from "react-router-dom";
import { SessionStorage } from "../helper/utils";

function PublicRoute() {
  let isAuth = SessionStorage();
  return !isAuth ? <Outlet /> : <Navigate to={{ pathname: "/dashboard" }} />;
}

export default PublicRoute;
